import { createContext, useContext } from 'react';

export type DetailsListContextProps = {
    isLoading?: boolean;
};

export const DetailsListContext = createContext<DetailsListContextProps | null>(null);

export const useDetailsListContext = (): DetailsListContextProps => {
    const context = useContext(DetailsListContext);
    if (!context) throw new Error('DetailsListItems need to be inside the DetailsList');
    return context;
};
